var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg080DecreaseVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17H8.59L12.08 20.49C12.3988 20.8152 12.8346 20.999 13.29 21C13.5139 20.998 13.7351 20.9503 13.94 20.86C14.5826 20.5989 15.0021 19.9736 15 19.28V4.72005C15.0007 4.02789 14.5841 3.40358 13.9446 3.13861C13.3052 2.87364 12.5691 3.02027 12.08 3.51005L8.59 7.00005H5C3.34315 7.00005 2 8.34319 2 10V14C2 15.6569 3.34315 17 5 17ZM4 10C4 9.44776 4.44772 9.00005 5 9.00005H9C9.2658 9.00158 9.52128 8.89723 9.71 8.71005L13 5.41005V18.59L9.71 15.29C9.52128 15.1029 9.2658 14.9985 9 15H5C4.44772 15 4 14.5523 4 14V10ZM16 12C16 11.4478 16.4477 11 17 11H21C21.5523 11 22 11.4478 22 12C22 12.5523 21.5523 13 21 13H17C16.4477 13 16 12.5523 16 12Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg080DecreaseVolume);
export default __webpack_public_path__ + "static/media/080-decrease-volume.ad6bfeba2cbdbc249c093f8c074a7c40.svg";
export { ForwardRef as ReactComponent };